import React from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  PageSection,
  PageSectionVariants,
  Title,
  TextContent,
  Text,
  TextVariants,
} from "@patternfly/react-core";
import CreateProductForm from "../components/product/CreateProductForm";

export default () => {
  return (
    <>
      <PageSection variant={PageSectionVariants.light}>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/product/list">Product</Link>
          </BreadcrumbItem>
          <BreadcrumbItem isActive>Add Product</BreadcrumbItem>
        </Breadcrumb>
        <Title headingLevel="h1" size="4xl" className="pf-c-title--PaddingTop">
          Create Product
        </Title>
        <TextContent>
          <Text component={TextVariants.h2}>
            Please edit the product info here:
          </Text>
        </TextContent>
      </PageSection>
      <PageSection isFilled variant={PageSectionVariants.light}>
        <CreateProductForm />
      </PageSection>
    </>
  );
};
